<template>
    <div class="buy-now-confirmation">
        <div :class="(order.size === '5lb' && !order.isSampler) ? 'coffee-bag-img-wrapper-5lb' : 'coffee-bag-img-wrapper-12oz'">
            <transition name="fade">
                <img v-show="bagImgLoaded" :src="order.bagImageUrl" class="coffee-bag-img" alt="Coffee Bag" v-on:load="bagImgLoaded = true">
            </transition>
        </div>

        <div class="user-address-wrapper">
            <strong>Going to:</strong>
            <p>{{ name }}</p>
            <p>{{ shipping.street1 }}</p>
            <p>{{ shipping.street2 }}</p>
            <p>{{ shipping.city }}, {{ shipping.state }}, {{ shipping.postalCode }}</p>
            <p v-if="creditCardLastDigits">************{{ creditCardLastDigits }}</p>
        </div>

        <div class="confirmation-content-wrapper">
            <h3 class="coffee-name">{{ order.coffeeName }}</h3>
            <p>{{ humanizeGrind(order.grind, true) }}</p>
            <p v-if="order.isSampler">{{ order.displaySize }} bags</p>
            <p v-else>{{ order.qty }} &times; {{ order.displaySize }}. bags</p>
            <p>Est. Delivery: {{ getEta() }}</p>
            <div class="margin-top-md">
                <template v-if="applicableCreditAmountCents && applicableCreditAmountCents > 0">
                    <p class="total-price">Total: {{ formatPrice(order.totalPrice) }} <span v-if="taxRate" class="font-sm"> (Incl. tax of {{ formatPrice(order.tax) }})</span></p>
                    <p v-if="order.qty > 1" class="font-green">({{ order.qty }} bag savings of {{ formatPrice(order.discount) }})</p>
                    <p class="total-price">Credit Used: {{ formatPrice(creditUsed) }}</p>
                    <p class="total-price"><strong>Amount Being Charged: {{ formatPrice(chargedAmount) }}</strong></p>
                </template>
                <template v-else>
                    <p class="total-price">Total: <strong>{{ formatPrice(order.totalPrice) }}</strong><span v-if="taxRate" class="font-sm"> (Incl. tax of {{ formatPrice(order.tax) }})</span></p>
                    <p v-if="order.qty > 1" class="font-green">({{ order.qty }} bag savings of {{ formatPrice(order.discount) }})</p>
                </template>
            </div>
        </div>

        <button @click="confirm()" class="btn-green-lg">
            <div v-if="processing" class="spinner">
                &nbsp
            </div>
            <span v-else>
                Complete Purchase
            </span>
        </button>

        <div v-if="!hasShippingAndBillingDetails && !isGift" class="home-form padded margin-top-md">
            <fieldset>
                <input type="checkbox" id="newsletter" v-model="subscribeNewsLetter">
                <label for="newsletter" class="checkbox-label font-sm">Join our newsletter for a chance to win free coffee every week!</label>
            </fieldset>
        </div>
    </div>
</template>

<script>
    import CommonMixin from "../../../mixins/common-mixin"
    import CoffeeMixin from "../../../mixins/coffee-mixin";
    import DateMixin from "../../../mixins/date-mixin";

    export default {
        mixins: [
            CommonMixin,
            CoffeeMixin,
            DateMixin
        ],
        props: {
            hasShippingAndBillingDetails: Boolean,
            order: Object,
            address: Object,
            name: String,
            shipping: Object,
            creditCardLastDigits: String,
            applicableCreditAmountCents: Number,
            isGift: Boolean,
            taxRate: Number
        },
        data: function() {
            return  {
                processing: false,
                bagImgLoaded: false,
                subscribeNewsLetter: true
            }
        },
        methods: {
            confirm() {
                if (this.processing) {
                    return;
                }
                this.processing = true;
                this.$emit('confirmed');
            },
            getEta() {
                const minDeliveryDays = 6;
                const maxDeliveryDays = 8;
                let range_min = new Date();
                let range_max = new Date();
                range_min.setDate(range_min.getDate() + minDeliveryDays);
                range_max.setDate(range_max.getDate() + maxDeliveryDays);
                return `${this.formatDateWithoutYear(range_min)} - ${this.formatDateWithoutYear(range_max)}`;
            }
        },
        computed: {
            creditUsed: function () {
                if (!this.applicableCreditAmountCents || !this.applicableCreditAmountCents > 0 ) {
                    return 0
                }
                return this.applicableCreditAmountCents > this.order.totalPrice ? this.order.totalPrice : this.applicableCreditAmountCents;
            },
            chargedAmount: function () {
                if (!this.applicableCreditAmountCents) {
                    return this.order.totalPrice;
                }

                if (this.applicableCreditAmountCents > this.order.totalPrice) {
                    return 0;
                }

                return this.order.totalPrice - this.applicableCreditAmountCents
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

    .buy-now-confirmation {
        text-align: center;
        padding-top: 1rem;
        padding-bottom: 2rem;

        p {
            margin: 0rem;
            line-height: normal;
        }
    }
    .coffee-bag-img-wrapper {
        min-height: 200px;
        margin-top: -46px;
        position: relative;
        top: 46px;
    }
    .coffee-bag-img-wrapper-12oz {
        @extend .coffee-bag-img-wrapper;
        text-align: left;
        .coffee-bag-img {
            width: 70%;
            height: 70%;
        }
    }
    .coffee-bag-img-wrapper-5lb {
        @extend .coffee-bag-img-wrapper;
        text-align: center;
        .coffee-bag-img {
            width: 50%;
            height: 50%;
            margin-bottom: 4rem;
        }
    }
    .user-address-wrapper {
        p {
            margin: 0;
        }
    }
    .confirmation-content-wrapper {
        padding-left: 2rem;
        padding-right: 2rem;
        margin-bottom: 2rem;
    }
    .coffee-name {
        font-weight: bold;
        color: $color-primary;
        line-height: 1.2;
    }
    .total-price {
        color: $green-primary;
        font-size: 20px;
    }
    .spinner {
        font-size: 3px!important;
    }
    .warning {
        color: $red-light;
        margin-bottom: 1rem!important;
    }
</style>
